import { useTranslation } from "react-i18next";
import useCrudTable from "../../../../../hooks/useCrudTable";
import { DefaultRouteTableColumns } from "../../domain/columns/DefaultRouteTableColumns";
import { defaultRouteSchema } from "../../domain/schema/DefaultRouteSchema";
import { useTranslatedColumns } from "../../../../general/modules/commons/tableTranslation/translatedColumns";
import useCrudFilters from "../../../../../hooks/useCrudFilters";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";

export const DefaultRoutePage = () => {
  const { t } = useTranslation("common");
  const dispatch = useAppDispatch();
  const title = t("Default routes");
  const currentUser = useAppSelector((state) => state.auth.user);

  const translatedColumns = useTranslatedColumns(DefaultRouteTableColumns);

  const crudFilters = useCrudFilters(
    {
      searchBy: "SearchByRootDefaultRoute",
      fields: {},
    },
    "defaultRouteFilter",
  );

  const crud = useCrudTable({
    prefix: "defaultRoutes",
    entity: "DefaultRoute",
    addAction: "/planning/default-route/add",
    columns: translatedColumns,
    schema: defaultRouteSchema,
    filters: crudFilters.filters,
    defaultSorting: [
      {
        id: "id",
        desc: true,
      },
    ],
  });

  if (!currentUser || currentUser.role === "dealer-employee") {
    return (
      <Layout>
        <LayoutContent>
          <Content>
            <ContentHeader className={"mt-3"} title={t("Access denied")} />
            <p className={"mt-3"}>{t("You don't have access to this page")}</p>
          </Content>
        </LayoutContent>
      </Layout>
    );
  }

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>
          <LayoutHeaderActions>{crud.addButton}</LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className={"mb-3"} />
          {crud.table}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
